import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/sections/Footer";
import Header from "../components/sections/Header";
import { API_MY_PLEDGED } from "../config/endpoints";
import { getLocalDataObject, getUserData } from "../helpers/Storage";

export default class MyPledged extends Component {
  constructor(props) {
    super(props);
    let userData = getUserData();
    let defaultArtist = getLocalDataObject("defaultArtist");
    this.state = {
      redirect: false,
      userProfile: userData.userProfile,
      isLoggedIn: userData.isLoggedIn,
      defaultArtist: defaultArtist,
      isLoading: false,
      myProjectsList: [],
      myStats: [],
      myPledged: [],
      amountByDays: [],
      selectedRanges: {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(),
        key: "selection",
      }, //range
    };
  }
  componentDidMount() {
    if (this.state.defaultArtist) {
      this.setState({
        isLoading: true,
      });
      fetch(API_MY_PLEDGED + "?artist_id=" + this.state.defaultArtist.id, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.success) {
          } else {
            this.setState({
              myPledged: data.data,
              isLoading: false,
            });
          }
        });
    }
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Pickfunder | MyCampaigns</title>
        </Helmet>
        <Header />
        {this.state.isLoading ? (
          <>
            <div className="coutom-spinner d-flex justify-content-center align-items-center">
              <div className="spinner-border text-light">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </>
        ) : (
          <>
            <section className="my-cam">
              <div className="contact">
                <h1>My Pledged</h1>
              </div>
            </section>
            <div className="container">
              <div className="row">
                <table className="table table-bordered mt-5 mb-5">
                  <tr>
                    <th>Title</th>
                    <th>Amount</th>
                    <th>Date</th>
                  </tr>
                  {this.state.myPledged.map((project, index) => (
                    <tr key={index}>
                      <td style={{ width: "60%" }}>
                        <div className="row">
                          <div className="col-md-2">
                            {project.event.avatar.originalImage ? (
                              <>
                                <img
                                  src={project.event.avatar.originalImage}
                                  className="d-block w-100 ui-bordered mr-4"
                                  alt="..."
                                />
                              </>
                            ) : (
                              <>
                                <img
                                  src="/images/banner.jpg"
                                  alt="reward-1"
                                  className="d-block w-100 ui-bordered mr-4"
                                />
                              </>
                            )}
                          </div>
                          <div className="col-md-6"> {project.event.name}</div>
                        </div>
                      </td>
                      <td>${project.amountTipped}</td>
                      <td>{project.createdAt}</td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </>
        )}
        <Footer />
      </>
    );
  }
}
